/**
 * <media-gallery> — thumbnail-driven stage, keyboard arrow navigation
 * between thumbnails, simple click-to-zoom (toggles a fullscreen class on
 * the clicked image; no separate zoom/pan library per brief section 36).
 */
class MediaGallery extends HTMLElement {
  constructor() {
    super();
    this.stage = this.querySelector('[data-media-gallery-stage]');
    this.thumbs = Array.from(this.querySelectorAll('[data-media-thumb]'));
  }

  connectedCallback() {
    this.thumbs.forEach((thumb) => thumb.addEventListener('click', () => this.setActive(thumb.dataset.mediaThumb)));
    this.addEventListener('keydown', this.onKeydown.bind(this));
    this.querySelectorAll('[data-media-zoom]').forEach((btn) => btn.addEventListener('click', () => this.toggleZoom(btn)));
  }

  setActive(mediaId) {
    this.stage.querySelectorAll('[data-media-id]').forEach((slide) => {
      const isMatch = slide.dataset.mediaId === mediaId;
      slide.hidden = !isMatch;
      slide.classList.toggle('is-active', isMatch);
    });
    this.thumbs.forEach((thumb) => {
      const isMatch = thumb.dataset.mediaThumb === mediaId;
      thumb.classList.toggle('is-active', isMatch);
      thumb.setAttribute('aria-selected', String(isMatch));
    });
  }

  onKeydown(event) {
    if (!['ArrowRight', 'ArrowLeft'].includes(event.key)) return;
    const activeIndex = this.thumbs.findIndex((t) => t.classList.contains('is-active'));
    if (activeIndex === -1) return;
    const delta = event.key === 'ArrowRight' ? 1 : -1;
    const nextIndex = (activeIndex + delta + this.thumbs.length) % this.thumbs.length;
    this.thumbs[nextIndex].focus();
    this.setActive(this.thumbs[nextIndex].dataset.mediaThumb);
  }

  toggleZoom(button) {
    const image = button.querySelector('img');
    if (!image) return;
    image.classList.toggle('is-zoomed');
    document.body.classList.toggle('media-gallery-zoom-open', image.classList.contains('is-zoomed'));
  }
}

customElements.define('media-gallery', MediaGallery);
